import PictureCardPictureTypes from './PictureCardPictureTypes'
export default PictureCardPictureTypes
